import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Select, Card, Typography, Row, Col, Form, Radio, InputNumber, DatePicker, Input } from 'antd';
import locale from 'antd/es/date-picker/locale/es_ES';
import { SET_PREVIEW_DATA } from '../../state/lease_contract/types';
import PropTypes from 'prop-types';

const { Title, Text } = Typography;
const { Option } = Select;

const VariableForm = ({ id, contractFormData, previewData, setPreview }) => {

  const [fines, setFines] = useState(contractFormData?.finesType);
  const [finesType, setFinesPrefix] = useState('');
  const [percentType, setPercentType] = useState('');
  const [rentType, setRentPrefix] = useState('');
  const [rentalValueReadjustment, setRentalValueReadjustment] = useState(contractFormData?.rentAdjustment);

  const setFinesType = (value) => {
    switch (value) {
      case 'Pesos':
        setFinesPrefix('$');
        setPercentType('');
        break;
      case 'UF':
        setFinesPrefix(value);
        setPercentType('');
        break;
      case '%':
        setFinesPrefix('');
        setPercentType(value);
        break;
    }
  };

  const setMonthlyRentType = (value) => {
    if (value === 'Pesos') {
      setRentPrefix('$');
    } else {
      setRentPrefix('UF');
    }
  };

  useEffect(() => {
    if (contractFormData && contractFormData.finesType) {
      setFines(true);
      if (contractFormData.finesType === '%') {
        setPercentType(contractFormData.finesType);
      } else if (contractFormData.finesType === 'Pesos') {
        setFinesPrefix('$');
      } else {
        setFinesPrefix(contractFormData.finesType);
      }
    };
    if (contractFormData && contractFormData.typeOfCurrency) {
      if (contractFormData.typeOfCurrency === 'Pesos') {
        setRentPrefix('$');
      } else {
        setRentPrefix(contractFormData.typeOfCurrency);
      }
    };
  }, [contractFormData]);

  const currencyFormatter = (rentType, value) => {
    if (rentType === 'UF') {
      return (`${rentType} ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
    } else {
      return (`${rentType}${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
    }
  };

  const savePreview = (data) => {
    setPreview({
      ...previewData,
      ...data
    });
  };

  return (
    <Card id={id} className="mb-4">
      <Row className="mb-2">
        <Col span={24}>
          <Title level={3} className="text-purple mb-0">Condiciones del contrato</Title>
          <p className="mb-4 subtitle-text">Ingresa los datos para generar las cláusulas del contrato</p>
          <Text strong>Información relevante</Text>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24} md={24} lg={12} className="position-relative">
          <div className="ant-col ant-form-item-label position-relative d-flex align-items-center">
            <label className="ant-form-item-required mr-1">El inmueble se arrienda a partir de</label>
          </div>
          <Form.Item
            name="initialLeaseDate"
            rules={[{ required: true, message: 'Debes seleccionar una fecha' }]}
          >
            <DatePicker
              locale={locale}
              size="large"
              format="DD-MM-YYYY"
              style={{ width: '100%' }}
              placeholder="Seleccionar"
              onChange={(value) => savePreview({ initialLeaseDate: new Date(value).toISOString() })}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24}>
          <div className="ant-col ant-form-item-label position-relative">
            <label className="ant-form-item-required mr-1">El contrato durará</label>
          </div>
        </Col>
        <Col xs={12} md={12} lg={6}>
          <Form.Item
            name="contractDurationNumber"
            rules={[{ required: true, message: 'Debes ingresar la cantidad de meses o años' }]}
            className="mb-0"
          >
            <InputNumber size="large" style={{ width: '100%' }}
              onChange={(event) => { savePreview({ contractDurationNumber: event }); }}
              formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
              parser={value => `${value}`.replace(/\$\s?|(,*)/g, '')}
              maxLength={10}
              min={1}
            />
          </Form.Item>
          <Text type="secondary" className="small d-block mb-4">Ej: 1 año</Text>
        </Col>
        <Col xs={12} md={12} lg={6} className="d-flex flex-shrink-0">
          <Form.Item
            name="contractDurationRange"
            rules={[{ required: true, message: 'Debes seleccionar una opción' }]}
            style={{ width: '100%' }}
            className="mb-0"
          >
            <Select size="large" style={{ width: '100%' }} placeholder="Seleccionar"
              onSelect={(value) => { savePreview({ contractDurationRange: value }); }}
            >
              <Option value="Mes(es)">Mes(es)</Option>
              <Option value="Año(s)">Año(s)</Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col xs={24} lg={24} className="position-relative">
          <div className="ant-col ant-form-item-label position-relative d-flex align-items-center">
            <label className="ant-form-item-required mr-1">Periodo de mes en que se deberá pagar el arriendo</label>
          </div>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24} md={24} lg={12} className="position-relative">
          <Form.Item
            name="paymentPeriod"
            rules={[{ required: true, message: 'Debes seleccionar una opción' }]}
            className="position-relative"
          >
            <Select
              className="mb-1"
              size="large"
              style={{ width: '100%' }}
              placeholder="Seleccionar"
              onSelect={(value) => { savePreview({ paymentPeriod: value }); }}
            >
              <Option value={1}>Día 1</Option>
              <Option value={5}>Día 5</Option>
              <Option value={10}>Día 10</Option>
              <Option value={20}>Día 20</Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col xs={24} className="d-flex align-items-center mb-2">
          <Title level={5} className="mb-0 mr-2">¿El contrato se renovará automáticamente?</Title>
        </Col>
        <Col>
          <Form.Item
            name="autoRenewal"
            rules={[{ required: true, message: 'Debes seleccionar una opción' }]}
          >
            <Radio.Group
              onChange={(option) => {
                previewData.autoRenewal = option.target.value;
                savePreview(previewData);
              }}
            >
              <Radio value={true}>Sí</Radio>
              <Radio value={false}>No</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col xs={24}>
          <Title level={5} className="mb-0 mr-2">¿El arriendo se pagará en pesos o UF?</Title>
        </Col>
        <Col>
          <Form.Item
            name="typeOfCurrency"
            rules={[{ required: true, message: 'Debes seleccionar una opción' }]}
          >
            <Radio.Group
              onChange={(option) => {
                setMonthlyRentType(option.target.value);
                previewData.typeOfCurrency = option.target.value;
                savePreview(previewData);
              }}
            >
              <Radio value='Pesos'>Pesos</Radio>
              <Radio value='UF'>UF</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col xs={24} lg={12}>
          <Form.Item
            name="monthlyRent"
            label="El valor mensual del arriendo será de"
            rules={[{ required: true, message: 'Debes ingresar un monto' }]}
          >
            <InputNumber
              formatter={value => currencyFormatter(rentType, value)}
              parser={value => value.replace(/\$|[a-zA-Z]\s?|(,*)/g, '')}
              style={{ width: '100%' }}
              size="large"
              onChange={(event) => { savePreview({ monthlyRent: event }); }}
              maxLength={15}
              min={0}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col xs={24} lg={24} className="position-relative">
          <div className="ant-col ant-form-item-label position-relative d-flex align-items-center">
            <label className="ant-form-item-required mr-1">Monto que se dejará en garantía</label>
          </div>
          <p className="subtitle-text">Usualmente el monto de la garantía es equivalente a un mes de renta.</p>
        </Col>
      </Row>
      <Row>
        <Col xs={24} lg={12} className="position-relative">
          <Form.Item
            name="guaranteeAmount"
            rules={[{ required: true, message: 'Debes ingresar la cantidad de meses' }]}
            className="position-relative"
          >
            <InputNumber
              formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
              parser={value => value.replace(/\$\s?|(,*)/g, '')}
              style={{ width: '100%' }}
              size="large"
              onChange={(event) => { savePreview({ guaranteeAmount: event }); }}
              maxLength={15}
              min={0}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col xs={24} className="d-flex align-items-center">
          <Title className="mr-1 mb-0" level={4} strong>Multas</Title>
        </Col>
        <Col xs={24} className="d-flex mb-2 align-items-center">
          <p className="subtitle-text">Lo usual es que se aplique multa por cada día de atraso en el pago de la renta.</p>
        </Col>
        <Col>
          <Form.Item
            name="finesType"
            rules={[{ required: true, message: 'Debes seleccionar una opción' }]}
          >
            <Radio.Group className="mb-2"
              onChange={(option) => {
                setFines(option.target.value);
                setFinesType(option.target.value);
                previewData.finesType = option.target.value;
                savePreview(previewData);
              }}
            >
              <Radio value='Pesos'>Pesos</Radio>
              <Radio value='UF'>UF</Radio>
              <Radio value='%'>Porcentaje</Radio>
              <Radio value={false}>Sin multa</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>
      {fines && (
        <>
          <Row>
            <Col xs={24} lg={24} className="position-relative">
              <div className="ant-col ant-form-item-label position-relative d-flex align-items-center">
                <label className="ant-form-item-required mr-1">
                  {fines === '%'
                    ? 'Porcentaje del arriendo mensual que se aplicará como multa por retraso diario de pago del arriendo'
                    : 'Monto de multa por retraso diario de pago de arriendo'}
                </label>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={24} md={12}>
              <Form.Item
                name="finesAmount"
                rules={[{ required: true, message: 'Debes ingresar monto de la multa' }]}
              >
                <InputNumber
                  formatter={value => `${finesType}${value}${percentType}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  parser={value => value.replace(/\$|[a-zA-Z]|%\s?|(,*)/g, '')}
                  style={{ width: '100%' }}
                  size="large"
                  onChange={(event) => { savePreview({ finesAmount: event }); }}
                  maxLength={15}
                  min={0}
                />
              </Form.Item>
            </Col>
          </Row>
        </>
      )}
      <Col xs={24}>
        <Col xs={24} className="d-flex align-items-center">
          <Title level={5} className="mb-0 mr-1">¿El arrendatario tendrá una sanción por poner término al contrato de forma anticipada? </Title>
        </Col>
        <Col xs={24} className="d-flex mb-2 align-items-center">
          <p className="subtitle-text">En el contrato aparecerá la cláusula que indicará que no se devolverá la garantía si el arrendatario pone término al contrato de forma anticipada.</p>
        </Col>
        <Form.Item
          name="sanction"
          rules={[{ required: true, message: 'Debes seleccionar una opción' }]}
        >
          <Radio.Group
            onChange={(option) => {
              previewData.sanction = option.target.value;
              savePreview(previewData);
            }}
          >
            <Radio value={true}>Sí</Radio>
            <Radio value={false}>No</Radio>
          </Radio.Group>
        </Form.Item>
      </Col>
      <Row className="mb-2">
        <Col xs={24} className="mb-2 d-flex align-items-center">
          <Title className="mr-1 mb-0" level={4}>Otros</Title>
        </Col>
        <Col xs={24} className="mb-2">
          <Col xs={24} className="d-flex mb-2 align-items-center">
            <Title level={5} className="mb-0 mr-1">¿Se prohibe tener animales en el inmueble?</Title>
          </Col>
          <Form.Item
            name="petBan"
            rules={[{ required: true, message: 'Debes seleccionar una opción' }]}
          >
            <Radio.Group
              onChange={(option) => {
                previewData.petBan = option.target.value;
                savePreview(previewData);
              }}
            >
              <Radio value={true}>Sí</Radio>
              <Radio value={false}>No</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
        <Col xs={24} className="d-flex align-items-center">
          <Title level={5} className="mb-0 mr-1">¿Quién será el responsable de pagar los gastos comunes?</Title>
        </Col>
        <Col xs={24} className="d-flex mb-2 align-items-center">
          <p className="subtitle-text">Lo usual es que sea el arrendatario el encargado de pagar los gastos comunes.</p>
        </Col>
        <Col>
          <Form.Item
            name="payCommonExpenses"
            rules={[{ required: true, message: 'Debes seleccionar una opción' }]}
          >
            <Radio.Group
              onChange={(option) => {
                previewData.payCommonExpenses = option.target.value;
                savePreview(previewData);
              }}
            >
              <Radio value={false}>No hay gastos comunes, nadie debe pagarlos</Radio>
              <Radio value='arrendatario'>El Arrendatario</Radio>
              <Radio value='arrendador'>El Arrendador</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
        <Col xs={24} className="mb-2 d-flex align-items-center">
          <Title level={5} className="mb-0 mr-1">¿Como se reajustará es valor del arriendo?</Title>
        </Col>
        <Col xs={24} lg={12}>
          <Form.Item
            name="rentAdjustment"
            rules={[{ required: true, message: 'Debes seleccionar una opción' }]}
          >
            <Radio.Group
              onChange={(option) => {
                previewData.rentAdjustment = option.target.value;
                savePreview(previewData);
                setRentalValueReadjustment(option.target.value);
              }}
            >
              <Radio value='ipc'>Según IPC</Radio>
              <Radio value='porcentaje'>En porcentaje</Radio>
              <Radio value={false}>No se reajusta</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
        {rentalValueReadjustment === 'ipc' &&
          <>
            <Col xs={24} className="mb-2 d-flex align-items-center">
              <label className="ant-form-item-required mr-1">¿Cada cuanto se ajustará es valor del arriendo según IPC?</label>
            </Col>
            <Col xs={24} lg={12}>
              <Form.Item
                name="IPCAdjustment"
                rules={[{ required: true, message: 'Debes seleccionar una opción' }]}
              >
                <Select size="large" style={{ width: '100%' }} placeholder="Seleccionar"
                  onSelect={(value) => { savePreview({ IPCAdjustment: value }); }}
                >
                  <Option value={false}>No se reajusta</Option>
                  <Option value="cada 3 meses">Cada 3 meses</Option>
                  <Option value="cada 6 meses">Cada 6 meses</Option>
                  <Option value="1 vez al año">1 vez al año</Option>
                </Select>
              </Form.Item>
            </Col>
          </>
        }
        {rentalValueReadjustment === 'porcentaje' &&
          <Row gutter={16}>
            <Col xs={24} lg={12}>
              <Form.Item
                name='percentAdjustment'
                label='Ingresa porcentaje de reajuste'
                rules={[{ required: true, message: 'Debes ingresar un número' }]}
              >
                <Input
                  size="large"
                  addonBefore="%"
                  onBlur={(event) => {
                    previewData['percentAdjustment'] = event.target.value;
                    savePreview(previewData);
                  }}
                  maxLength={3}
                  onKeyUp={({ target }) => { target.value = target.value.replace(/[\D]+/g, ''); }}
                />
              </Form.Item>
            </Col>
            <Col xs={24}>
              <div className="ant-col ant-form-item-label position-relative">
                <label className="ant-form-item-required mr-1">Ingresa cada cuanto se reajusta</label>
              </div>
            </Col>
            <Col xs={12} md={12} lg={6}>
              <Form.Item
                name="readjustmentValue"
                rules={[{ required: true }]}
                className="mb-0"
              >
                <InputNumber size="large"
                  onChange={(event) => { savePreview({ readjustmentValue: event }); }}
                  maxLength={3}
                  min={1}
                />

              </Form.Item>
            </Col>
            <Col xs={12} md={12} lg={6} className="d-flex flex-shrink-0">
              <Form.Item
                name="readjustmentRange"
                rules={[{ required: true, message: 'Debes seleccionar una opción' }]}
                style={{ width: '100%' }}
                className="mb-0"
              >
                <Select size="large" style={{ width: '100%' }} placeholder="Seleccionar"
                  onSelect={(value) => { savePreview({ readjustmentRange: value }); }}
                >
                  <Option value="Mes(es)">Mes(es)</Option>
                  <Option value="Año(s)">Año(s)</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
        }
      </Row>
    </Card>
  );
};

VariableForm.propTypes = {
  id: PropTypes.string.isRequired,
  contractFormData: PropTypes.object.isRequired,
  previewData: PropTypes.object.isRequired,
  setPreview: PropTypes.func.isRequired,
};

const data = (state) => ({
  contractFormData: state.contract.contractFormData,
  previewData: state.contract.previewData,
});

const actions = (dispatch) => ({
  setPreview: (data) => dispatch({ type: SET_PREVIEW_DATA, payload: { ...data } }),
});

export default connect(data, actions)(VariableForm);